// Vertical Mode Cart Marker
// Marks the cart with a hidden attribute to identify sales made in vertical mode
(function() {
  // Capture and store 'retail' parameter from URL
  (function captureRetailParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const retailParam = urlParams.get('retail');
    
    if (retailParam) {
      localStorage.setItem('retail-location', retailParam);
      console.log('[VerticalCartMarker] Retail location captured:', retailParam);
    }
  })(); 

  // Only mark cart in vertical mode
  function isVerticalMode() {
    return document.documentElement.classList.contains('display-vertical');
  }

  if (!isVerticalMode()) {
    return;
  }

  console.log('[VerticalCartMarker] Vertical mode detected - checking cart attributes');

  // Check if cart already has the vertical mode attribute
  async function checkAndMarkCart() {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Get retail location from localStorage and current URL
      const urlParams = new URLSearchParams(window.location.search);
      const currentRetailParam = urlParams.get('retail');
      const storedRetailLocation = localStorage.getItem('retail-location');
      const retailLocation = currentRetailParam || storedRetailLocation || 'Sin especificar';

      // Check if we need to update the cart attributes
      const needsUpdate = !cart.attributes 
        || !cart.attributes.modo_venta 
        || !cart.attributes.venta_retail
        || cart.attributes.venta_retail !== retailLocation;

      if (!needsUpdate) {
        console.log('[VerticalCartMarker] Cart already marked with current retail location:', retailLocation);
        return;
      }

      console.log('[VerticalCartMarker] Updating cart with retail location:', retailLocation);

      // Add/Update the vertical mode attributes
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'modo_venta': 'Modo Vertical',
            'venta_retail': retailLocation,
            'fecha_inicio_vertical': null  // Remove old attribute if exists
          }
        })
      }); 

      if (updateResponse.ok) {
        console.log('[VerticalCartMarker] Cart successfully marked/updated with vertical mode attributes');
        console.log('[VerticalCartMarker] Retail location:', retailLocation);
      } else {
        throw new Error('Failed to update cart attributes');
      }

    } catch (error) {
      console.error('[VerticalCartMarker] Error marking cart:', error);
    }
  }

  // Run the check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndMarkCart);
  } else {
    checkAndMarkCart();
  }

})();
